export const actionsCreator = ({ setState }) => ({
  SET_FILTER: (data) =>
    setState((state) => ({
      appliedFilterData: {
        ...state.appliedFilterData,
        ...data
      },
      currentFilterData: data
    })),

  CHANGE_FILTER: (data) =>
    setState((state) => ({
      currentFilterData: { ...state.currentFilterData, ...data }
    })),

  COUNT_CHANGES: ({ changesCount, isChanged }) =>
    setState({ changesCount, isChanged })
});

export const filtersActions = actionsCreator({});
